module.exports = __webpack_public_path__ + "img/WaterYouDoingNoLogo_12300x5006.d0bc22a1.png";